import FORMAT from 'config/date/format';
import moment from 'moment'

const thismonth = datestring =>  moment(datestring, FORMAT).diff(moment(), 'hours') > 0 && moment(datestring, FORMAT).isSame(moment(), 'month');

export default events => events?.filter(e => thismonth(e.start_date)) || [];
// ({
//         type: categories.THISMONTH,
//         data: events?.filter(e => [2,3].includes(e.id)) || []
//     });